// Older javascript code should continue to import this module like this:
//
// var log = require('../../log/Log').channel('MyFile');
// log.info('hello');
//
// Newer typescript code should import this module like this:
//
// import { Log } from '../../log';
// const log = Log.channel('MyFile');
// log.info('hello');
class LogImpl {
    constructor() {
        this.buffers = {};
        this.bufferHidden = {};
        this.channels = {};
        this.defaultLogger = {
            debug: console.log,
            error: console.error,
            info: console.info,
            warning: console.warn,
        };
        this.errorCallbacks = [];
        this._messageLimit = 0;
        this.lineLimit = 1000;
        this.formatMessage = this.defaultFormatter;
        this.logger = this.defaultLogger;
    }
    get messageLimit() {
        return this._messageLimit;
    }
    set messageLimit(value) {
        this._messageLimit = value;
    }
    channel(channelName, bufferName = 'default') {
        const name = `${channelName}.${bufferName}`;
        if (!this.buffers[bufferName]) {
            this.buffers[bufferName] = [];
        }
        if (!this.channels[name]) {
            this.channels[name] = new LogChannelImpl(channelName, bufferName, this.log.bind(this));
        }
        return this.channels[name];
    }
    clearBuffer() {
        for (const name of Object.keys(this.buffers)) {
            this.buffers[name] = []; // don't set length = 0 in case someone is holding a reference
        }
    }
    getBuffer() {
        const buffer = [];
        for (const buf of Object.values(this.buffers)) {
            buf.forEach(e => buffer.push(e));
        }
        return buffer.sort((a, b) => a.time - b.time);
    }
    hideBuffer(bufferName, hidden) {
        this.bufferHidden[bufferName] = hidden;
    }
    onError(callback) {
        this.errorCallbacks.push(callback);
    }
    addToBuffer(level, channelName, message, bufferName) {
        const entry = {
            channel: channelName,
            level,
            message,
            time: Date.now(),
        };
        if (bufferName !== 'default')
            entry.buffer = bufferName;
        const buffer = this.buffers[bufferName];
        buffer.push(entry);
        if (buffer.length > this.lineLimit)
            buffer.shift();
    }
    defaultFormatter(level, channelName, message) {
        return `${channelName}: ${message}`;
    }
    log(level, channelName, bufferName, message) {
        if (this._messageLimit > 0 && message.length > this._messageLimit) {
            message = message.slice(0, this._messageLimit) + '...';
        }
        this.addToBuffer(level, channelName, message, bufferName);
        if (!this.bufferHidden[bufferName]) {
            this.logger[level](this.formatMessage(level, channelName, message));
        }
        if (level === 'error')
            this.errorCallbacks.forEach(cb => cb());
    }
}
class LogChannelImpl {
    constructor(name, bufferName, logger) {
        this.name = name;
        this.bufferName = bufferName;
        this.logger = logger;
        this.debugEnabled = true;
    }
    debug(message) {
        if (this.debugEnabled)
            this.logger('debug', this.name, this.bufferName, message);
    }
    error(message) {
        this.logger('error', this.name, this.bufferName, message);
    }
    info(message) {
        this.logger('info', this.name, this.bufferName, message);
    }
    warning(message) {
        this.logger('warning', this.name, this.bufferName, message);
    }
}
export const Log = new LogImpl();
